import type { LaunchContext } from '@frontend/logrocket';
import Session, { APPLICATION_NAME } from './Session';

// True when partner-ui runs inside a parent host (ENCW / TPO iframe) rather than
// being opened directly at its own URL. Cross-origin reads on window.top throw,
// which itself means we are embedded.
const isEmbedded = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

// Resolves how partner-ui was launched from the SSF application descriptor
// (set by Common.sourceApplicationName) plus an iframe check. Must be called
// after sourceApplicationName has resolved for ENC/TPO to be detected.
export const getLaunchContext = (): LaunchContext => {
  const appName = Session.get(APPLICATION_NAME);
  if (appName === 'TPO') return 'tpo';
  if (appName === 'ENC') return 'smartclient';
  return isEmbedded() ? 'encw' : 'standalone';
};

// The host forwards lrAppId once it wires up the iframe session merge.
const hostForwardsLogRocketParams = (): boolean => {
  try {
    return !!new URLSearchParams(window.location.search).get('lrAppId');
  } catch {
    return false;
  }
};

// SmartClient and standalone record as their own identified session. ENCW/TPO
// should merge into the parent host session (no identify), but until the host
// wires that up (signaled by lrAppId) we identify them so they aren't anonymous.
// TEMPORARY: drop the ENCW/TPO branch once host-side merge is confirmed.
export const shouldIdentifyOwnSession = (
  context: LaunchContext = getLaunchContext(),
): boolean => {
  if (context === 'smartclient' || context === 'standalone') return true;
  return !hostForwardsLogRocketParams();
};
